<template>
    <span>
        win {{win.width}}x{{win.height}} |
        win in {{win.innerWith}}x{{win.innerHeight}} |
        screen {{screen.width}}x{{screen.height}} |
        screen css {{screen.availWidth}}x{{screen.availHeight}}
    </span>
</template>
<script>
    export default {
        name: 'ScreenSizes',
        components: {
        },
        data(){
            return{
                win: {
                    width: 0,
                    height: 0,
                    innerWith:0,
                    innerHeight:0,
                },
                screen: {
                    width: 0,
                    height: 0,
                    availWidth: 0,
                    availHeight: 0,
                }
            }
        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        methods: {
            handleResize() {
                this.win.width = window.outerWidth;
                this.win.height = window.outerHeight;

                this.win.innerWith=window.innerWidth;
                this.win.innerHeight=window.innerHeight;

                this.screen.width=screen.width;
                this.screen.height=screen.height;
                this.screen.availHeight=screen.availHeight;
                this.screen.availWidth=screen.availWidth;
            }
        }
    }
</script>